import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=4654295b&scoped=true&"
import script from "./DocumentViewer.vue?vue&type=script&lang=ts&"
export * from "./DocumentViewer.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=4654295b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654295b",
  null
  
)

export default component.exports